var EHDI = EHDI || Object.create(null);
var WTE = WTE || Object.create(null);
var UTILS = UTILS || Object.create(null);
var POOLS = POOLS || Object.create(null);


WTE.Cage  = function() 
{
    EHDI.aka.Container.call(this);

    this.init = function(depth)
    {
        this.isOccupied = false;
        this.isFlipped = false;
        this.occupant = null;
        this.depthFactor = depth;

        
    }

    this.addAnimal = function(animal)
    {
        if(this.isOccupied)
            return;

        this.occupant = animal;

        if(this.isFlipped)
            this.occupant.scale.x = -1 * this.depthFactor;
        else
            this.occupant.scale.x = this.depthFactor;
        this.occupant.scale.y = this.depthFactor;
        
        this.addChild(this.occupant);

        this.isOccupied = true;
    }

    this.releaseAnimal = function()
    {
        if(this.occupant == null)
            return;

        this.removeChild(this.occupant);
        this.occupant.scale.x = 1 * this.depthFactor;
        this.occupant.scale.y = 1;
        this.occupant = null;
        this.isOccupied = false;    
    }
}
WTE.Cage.prototype = Object.create(EHDI.aka.Container.prototype);